import React, { FC, useState } from 'react';
import _ from 'lodash';
import { ClearAll, updateQueryParams } from '@utils/route';
import { useShallowRouter } from '@components/Hooks/useRouter';
import Services from '../../Filters/Services';
import MobileLocationFilter from '../MobileLocationFilter';
import MobileLanguageFilter from '../MobileLanguageFilter';
import MenuWithBudgetScreen from './MenuWithBudgetScreen';
import { Modal } from '@wix/design-system';

type Props = {
  setOpenMobileFilter: (shouldOpenFilter: boolean) => void;
};

export const menuSelectionKeys = {
  MENU_WITH_BUDGET: 'MENU_WITH_BUDGET',
  SERVICES: 'SERVICES',
  LOCATION: 'LOCATION',
  LANGUAGE: 'LANGUAGE',
} as const;

const MobileFilterMenu: FC<Props> = ({ setOpenMobileFilter }) => {
  const { navigate, router } = useShallowRouter();
  const [clearWasClicked, setClearWasClicked] = useState<ClearAll>({
    services: false,
    language: false,
    location: false,
    all: false,
  });

  const [activeRow, setActiveRow] = useState<keyof typeof menuSelectionKeys>(
    menuSelectionKeys.MENU_WITH_BUDGET,
  );

  const onBack = () => {
    setActiveRow(menuSelectionKeys.MENU_WITH_BUDGET);
  };

  const closeModal = () => {
    setOpenMobileFilter(false);
  };

  const onClose = () => {
    navigate(updateQueryParams({}, router, clearWasClicked));
    closeModal();
  };

  const getActiveScreen = () => {
    switch (activeRow) {
      case menuSelectionKeys.MENU_WITH_BUDGET: {
        return (
          <MenuWithBudgetScreen
            onClose={onClose}
            clearWasClicked={clearWasClicked}
            setClearWasClicked={setClearWasClicked}
            setOpenMobileFilter={setOpenMobileFilter}
            setActiveRow={setActiveRow}
          />
        );
      }
      case menuSelectionKeys.LANGUAGE: {
        return (
          <MobileLanguageFilter
            onBack={onBack}
            onClose={onClose}
            closeModal={closeModal}
            clearWasClicked={clearWasClicked}
            setClearWasClicked={setClearWasClicked}
          />
        );
      }
      case menuSelectionKeys.LOCATION: {
        return (
          <MobileLocationFilter
            onBack={onBack}
            onClose={onClose}
            closeModal={closeModal}
            clearWasClicked={clearWasClicked}
            setClearWasClicked={setClearWasClicked}
          />
        );
      }
      case menuSelectionKeys.SERVICES: {
        return (
          <Services
            clearWasClicked={clearWasClicked}
            setClearWasClicked={setClearWasClicked}
            onBack={onBack}
            onClose={onClose}
            closeModal={closeModal}
            isMobile={true}
          />
        );
      }
      default: {
        return (
          <MenuWithBudgetScreen
            onClose={onClose}
            clearWasClicked={clearWasClicked}
            setClearWasClicked={setClearWasClicked}
            setOpenMobileFilter={setOpenMobileFilter}
            setActiveRow={setActiveRow}
          />
        );
      }
    }
  };

  return (
    <Modal
      isOpen={true}
      screen="mobile"
      closeTimeoutMS={0}
      dataHook="mobile-filter-menu"
    >
      {getActiveScreen()}
    </Modal>
  );
};

export default MobileFilterMenu;
